import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface FormValuesState {
  patientBudget: {
    selectedCurrencies: {
      isContractCurrency: boolean;
      isPrimaryCurrency: boolean;
    };
    site_ids: string[];
  };
  patientTracker: {
    selectedCurrencies: {
      isContractCurrency: boolean;
      isPrimaryCurrency: boolean;
    };
    site_ids: string[];
  };
}

export function createInitialState(): FormValuesState {
  return {
    patientBudget: {
      selectedCurrencies: {
        isContractCurrency: true,
        isPrimaryCurrency: true,
      },
      site_ids: [],
    },
    patientTracker: {
      selectedCurrencies: {
        isContractCurrency: true,
        isPrimaryCurrency: true,
      },
      site_ids: [],
    },
    ...JSON.parse(localStorage.getItem('formValues') || '{}'),
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'form-values' })
export class FormValuesStore extends Store<FormValuesState> {
  constructor() {
    super(createInitialState());
  }
}
